import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  IconButton,
  CardContent,
  Stack,
  Chip,
  Avatar,
  Drawer,
  useMediaQuery,
  Divider,
  Tooltip,
  MenuItem,
  Menu,
} from "@mui/material";
import {
  useDeleteConversationsMessagesMutation,
  useDoneMeetingMutation,
  useGetCustomerQuery,
  useGetConversationsQuery,
  useGetTeamQuery,
  useCreateConversationsMessagesMutation,
  useCreateConversationsMutation,
  useGetAllConversationsSubjectQuery,
  useGetConversationsHistoriesQuery,
  useGetUserInfoOnyQuery,
  useGetCustomerFilterByPerentQuery,
  useGetConversationsMessagesQuery,
  useConversationsMessagesAsReadQuery,
} from "../../../Api/attoDeskApi";
import {
  ICustomer,
  ITeam,
  IToDoMessage,
  IToDo,
  IToDoHistory,
  IUserAdmin,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import Autocomplete from "@mui/material/Autocomplete";
import useUser from "../../../Core/hook/useUser";
import { useParams } from "react-router-dom";
import { useFormik } from "formik";
import { FaEdit } from "react-icons/fa";
import { styled, useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import GroupIcon from "@mui/icons-material/Group";
import ReactQuill from "react-quill";
import SendIcon from "@mui/icons-material/Send";
import "react-quill/dist/quill.snow.css";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { BASENAME } from "../../../config/index";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { toProperCase } from "../../../Components/Validation/toProperCase";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

interface CustomerOption {
  label: string;
  value: number;
}

interface FormValues {
  staffIds: number[];
  subject: string;
  id: string;
}

interface FormValues2 {
  tagged_client_ids: number[];
  note: string;
  conversationId: string;
}

interface FormValues3 {
  id: string;
  tagged_client_ids: number[];
  note: string;
  conversationId: string;
}

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const variantPropName = (unit: string) => {
  switch (unit) {
    case "subject":
      return "Subject";
    case "staffIds":
      return "Staff";
    default:
      return "";
  }
};

const Index = () => {
  const classes = useStyles();
  const { id: todoId } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { userHasRight } = useUser();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [selectedCoursing, setSelectedCoursing] = useState<IToDoMessage | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState<IToDoMessage | null>(
    null
  );
  const [openDialogMeeting, setOpenDialogMeeting] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IToDoMessage | null>(
    null
  );
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(dayjs());
  const [selectedJoinCustomerId, setSelectedJoiCustomerId] = useState<
    string | ""
  >("");

  const [openDoneMeeting, setOpenDoneMeeting] = useState(false);
  const [meetingToDone, setMeetingToDone] = useState<IToDoMessage | null>(null);
  const [editOpen, setEditOpen] = useState(false);
  const [showType, setShowType] = useState(false);
  const [showTag, setShowTag] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [selectedIsBooked, setSelectedProductIsBooked] =
    useState<string>("AllType");
  const [selectedClient, setSelectedClient] = useState<string>("all");
  const [selectedClientCat, setSelectedClientCat] = useState<string>("all");

  const containerRef = useRef<HTMLDivElement | null>(null);
  const [showScrollDown, setShowScrollDown] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedMsg, setSelectedMsg] = useState<any>(null);

  const [newDepartment, { isLoading }] = useCreateConversationsMutation();
  const [newConversionHistory, { isLoading: conIsLoading }] =
    useCreateConversationsMessagesMutation();

  const {
    data,
    isLoading: todoIsLoading,
    isError,
    refetch,
  } = useGetConversationsQuery({
    searchText: "",
    staffId: "",
    id: String(todoId),
  });

  const {
    data: conversationsHistoriesData,
    isLoading: conversationsHistoriesIsLoading,
  } = useGetConversationsHistoriesQuery({
    searchText: "",
    staffId: "",
    id: String(todoId),
  });

  const {
    data: conversationsMessageData,
    isLoading: conversationsMessageIsLoading,
  } = useGetConversationsMessagesQuery(
    { id: String(todoId) },
    {
      pollingInterval: 2000,
    }
  );
  const { data: readMessageData, isLoading: readMessageIsLoading } =
    useConversationsMessagesAsReadQuery(
      { id: String(todoId) },
      {
        pollingInterval: 2000,
      }
    );
  const { data: staffData, isLoading: staffIsLoading } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const { data: teamData, isLoading: teamsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: meetingAllData, isLoading: meetingAllIsLoading } =
    useGetAllConversationsSubjectQuery({
      searchText: "",
      id: "",
    });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const { data: clientData, isLoading: clientIsLoading } =
    useGetCustomerFilterByPerentQuery({
      searchText: currentSearchQuery,
      id: "",
      // isParent: selectedIsBooked,
      isParentFilter: selectedClientCat,
      isParent:
        selectedIsBooked && selectedIsBooked !== "AllType"
          ? selectedIsBooked
          : "",
      customerClientId: selectedClient,
    });

  const { data: allClientData, isLoading: allClientIsLoading } =
    useGetCustomerFilterByPerentQuery({
      searchText: "",
      id: "",
      // isParent: selectedIsBooked,
      isParentFilter: "",
      isParent: "all",
      customerClientId: "all",
    });

  const cliendUpList = useMemo(() => {
    return (clientData?.data ?? []) as ICustomer[];
  }, [clientData?.data]);

  const allCliendUpList = useMemo(() => {
    return (allClientData?.data ?? []) as ICustomer[];
  }, [allClientData?.data]);

  const cliendList = useMemo(() => {
    return (teamData?.data ?? []) as ITeam[];
  }, [teamData?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const firstToDo = useMemo(() => {
    return (data?.data as IToDo[])?.[0];
  }, [data?.data]);

  const conversationsHistoriesList: IToDoHistory[] = Array.isArray(
    conversationsHistoriesData?.data
  )
    ? (conversationsHistoriesData?.data as IToDoHistory[])
    : [];

  const clientOptions = useMemo(() => {
    if (!Array.isArray(cliendUpList)) return [];
    return cliendUpList.map((cust) => ({
      label: `${toProperCase(cust.customerFirstName)} ${toProperCase(
        cust.customerLastName
      )}`,
      value: cust.id,
    }));
  }, [cliendUpList]);

  const staffOptions = useMemo(() => {
    if (!Array.isArray(cliendList)) return [];
    return cliendList.map((cust) => ({
      label: `${toProperCase(cust.teamFirstName)} ${toProperCase(
        cust.teamLastName
      )}`,
      value: cust.id,
    }));
  }, [cliendList]);

  // const staffMap = useMemo(() => {
  //   if (!Array.isArray(cliendList)) return {};
  //   return cliendList.reduce((acc, cust) => {
  //     const name = `${capitalizeFirstLetter(
  //       cust.teamFirstName
  //     )} ${capitalizeFirstLetter(cust.teamLastName)}`;
  //     acc[cust.id] = { name };
  //     return acc;
  //   }, {} as Record<number, { name: string }>);
  // }, [cliendList]);

  const allClientMap = useMemo(() => {
    const map = new Map();
    allCliendUpList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [allCliendUpList]);

  const staffMap = useMemo(() => {
    const map = new Map();
    cliendList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.teamFirstName || "") +
          " " +
          toProperCase(category.teamLastName || "")
      );
    });
    return map;
  }, [cliendList]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.staff}`);
    });
    return map;
  }, [userList]);

  // const userMap = useMemo(() => {
  //   const map = new Map<string, string>();

  //   const staffMap = new Map<string, string>();
  //   cliendList2?.forEach((cust) => {
  //     const fullName = `${capitalizeFirstLetter(cust.teamFirstName)} ${capitalizeFirstLetter(cust.teamLastName)}`;
  //     staffMap.set(cust.id, fullName); // use cust.id as string
  //   });

  //   userList?.forEach((user) => {
  //     if (user.staffId && staffMap.has(user.staffId)) {
  //       map.set(user.id, staffMap.get(user.staffId)!); // staff name
  //     } else {
  //       map.set(user.id, user.user_role_name); // fallback
  //     }
  //   });

  //   return map;
  // }, [userList, cliendList2]);

  const coursings: IToDoMessage[] = Array.isArray(
    conversationsMessageData?.data
  )
    ? (conversationsMessageData?.data as IToDoMessage[])
    : [];

  const handleScroll = () => {
    if (!containerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;

    // If scrolled less than 100px from bottom, hide arrow; else show
    if (scrollHeight - scrollTop - clientHeight > 100) {
      setShowScrollDown(true);
    } else {
      setShowScrollDown(false);
    }
  };

  // Scroll to bottom function
  const scrollToBottom = () => {
    containerRef.current?.scrollTo({
      top: containerRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  // Automatically scroll to bottom on new messages
  useEffect(() => {
    scrollToBottom();
  }, [coursings]);
  const handleIsBooked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setPaymentMonthYear(dayjs(selectedValue));
  };

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleOpenDialog = (coursing: IToDoMessage) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDialogMeeting = (coursing: IToDoMessage) => {
    setSelectedMeeting(coursing);
    setOpenDialogMeeting(true);
  };

  const handleCloseDialogMeeting = () => {
    setSelectedMeeting(null);
    setOpenDialogMeeting(false);
  };

  const handleOpenDeletePopup = (coursing: IToDoMessage) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleOpenDonePopup = (coursing: IToDoMessage) => {
    setMeetingToDone(coursing);
    setOpenDoneMeeting(true);
  };

  const handleCloseDonePopup = () => {
    setMeetingToDone(null);
    setOpenDoneMeeting(false);
  };

  const handleEditClick = () => {
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
  };

  const handleIsClient = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedClient(selectedValues);
  };

  const handleIsClientCat = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValues = event.target.value;
    setSelectedClientCat(selectedValues);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    setShowEdit(true);
  };

  const handleDelete2 = () => {
    handleClose();
    setShowEdit(false);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
    setShowEdit(false);
  };

  const formik = useFormik<FormValues>({
    initialValues: {
      staffIds: [],
      subject: "",
      id: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          id: values.id,
          staffIds: values.staffIds,
          subject: capitalizeFirstLetter(values.subject),
        };
        const addCompanyResponse = await newDepartment(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formikMessage = useFormik<FormValues2>({
    initialValues: {
      tagged_client_ids: [],
      note: "",
      conversationId: String(todoId),
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          conversationId: String(todoId),
          tagged_client_ids: values.tagged_client_ids,
          note: values.note,
        };
        const addCompanyResponse = await newConversionHistory(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          formikMessage.resetForm();
          setShowTag(false);
          setShowType(false);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formikMessageEdit = useFormik<FormValues3>({
    initialValues: {
      tagged_client_ids: coursingToDelete?.tagged_client_ids || [],
      note: coursingToDelete?.note || "",
      conversationId: coursingToDelete?.conversationId || String(todoId),
      id: coursingToDelete?.id || "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          conversationId: String(todoId),
          tagged_client_ids: values.tagged_client_ids,
          note: values.note,
          id: values.id,
        };
        const addCompanyResponse = await newConversionHistory(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          setCoursingToDelete(null);
          formikMessage.resetForm();
          setShowEdit(false);
          setShowTag(false);
          setShowType(false);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (firstToDo) {
      formik.setValues({
        staffIds: firstToDo.staffIds || [],
        subject: firstToDo.subject || "",
        id: firstToDo.id || "",
      });
    }
  }, [firstToDo]);

  useEffect(() => {
    if (coursingToDelete) {
      formikMessageEdit.setValues({
        tagged_client_ids: coursingToDelete?.tagged_client_ids || [],
        note: coursingToDelete?.note || "",
        conversationId: coursingToDelete?.conversationId || String(todoId),
        id: coursingToDelete?.id || "",
      });
    }
  }, [coursingToDelete]);

  //   useEffect(() => {
  //   if (todoId) {
  //     formikMessage.setValues({
  //       conversationId: String(todoId),

  //     });
  //   }
  // }, [todoId]);

  const formValid = useMemo(() => {
    return (
      formik.values.staffIds.length > 0 && formik.values.subject.trim() !== ""
    );
  }, [formik.values.staffIds, formik.values.subject]);

  const formValidMessage = useMemo(() => {
    return (
      formikMessage.values.conversationId.trim() !== "" &&
      (formikMessage.values.note.trim() !== "" ||
        formikMessage.values.tagged_client_ids.length > 0)
    );
  }, [
    formikMessage.values.conversationId,
    formikMessage.values.note,
    formikMessage.values.tagged_client_ids,
  ]);

  const formValidMessageEdit = useMemo(() => {
    return (
      formikMessageEdit.values.conversationId !== "" &&
      (formikMessageEdit.values.note.trim() !== "" ||
        formikMessageEdit.values.tagged_client_ids.length > 0)
    );
  }, [
    formikMessageEdit.values.conversationId,
    formikMessageEdit.values.note,
    formikMessageEdit.values.tagged_client_ids,
  ]);

  const handleDateChange = (newValue: Dayjs | null) => {
    setSelectedDate(newValue);

    if (newValue) {
      const mockEvent = {
        target: {
          value: newValue.format("YYYY-MM-DD"),
        },
      } as React.ChangeEvent<HTMLInputElement>;

      handleIsBooked(mockEvent);
    }
  };

  const goToPreviousDay = () => {
    const prevDay =
      selectedDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleDateChange(prevDay);
  };

  const goToNextDay = () => {
    const nextDay = selectedDate?.add(1, "day") || dayjs().add(1, "day");
    handleDateChange(nextDay);
  };

  const [deleteCategory] = useDeleteConversationsMessagesMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setCoursingToDelete(null);
        setOpenDeleteCategory(false);
        setShowEdit(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the position");
    }
  };

  const [deleteDoneMeeting] = useDoneMeetingMutation();
  const handleDeleteDoneMeeting = async (id: string) => {
    try {
      const response = await deleteDoneMeeting(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDoneMeeting(false);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the meeting done");
    }
  };

  if (
    staffIsLoading ||
    teamsLoading ||
    todoIsLoading ||
    conversationsHistoriesIsLoading ||
    meetingAllIsLoading ||
    userIsLoading ||
    clientIsLoading ||
    conversationsMessageIsLoading
    // readMessageIsLoading
  )
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Grid container spacing={3}>
        {firstToDo ? (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card
              elevation={2}
              sx={{
                borderRadius: 3,
                p: 2,
                mb: 3,
                backgroundColor: theme.palette.cardAdd.bgColor,
              }}
            >
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.activityHistoryHeaderGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Grid
                          container
                          spacing={3}
                          alignItems="flex-start"
                          className={classes.activityHistoryHeaderGrid}
                        >
                          <Grid item xs={12} md={8}>
                            <Grid
                              container
                              spacing={2}
                              alignItems="center"
                              onClick={handleEditClick}
                              sx={{
                                cursor: "pointer",
                                "&:hover .edit-icon": {
                                  opacity: 1,
                                },
                              }}
                            >
                              <Grid item>
                                <Avatar
                                  sx={{
                                    bgcolor: "primary.main",
                                    width: 56,
                                    height: 56,
                                    fontSize: 24,
                                    fontWeight: "bold",
                                  }}
                                >
                                  {/* {firstToDo.subject?.charAt(0).toUpperCase()} */}
                                  {firstToDo?.subject ? (
                                    firstToDo.subject.charAt(0).toUpperCase()
                                  ) : (
                                    <GroupIcon />
                                  )}
                                </Avatar>
                              </Grid>
                              <Grid item>
                                <Typography
                                  className={classes.mL1Heading}
                                  fontWeight={700}
                                >
                                  {firstToDo?.subject || ""}
                                </Typography>

                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Task group overview
                                </Typography>
                              </Grid>
                            </Grid>
                            {!isMobile && (
                              <>
                                <Typography
                                  className={classes.mL1Heading2}
                                  sx={{ mt: 3, mb: 1 }}
                                  color="text.secondary"
                                >
                                  Group Members
                                </Typography>
                                {firstToDo?.staffIds?.length ? (
                                  <Stack
                                    direction="row"
                                    flexWrap="wrap"
                                    gap={1}
                                    sx={{
                                      maxHeight: 200,
                                      overflowY: "auto",
                                    }}
                                  >
                                    {firstToDo.staffIds.map((id) => {
                                      const name =
                                        staffMap.get(id) ?? `Staff #${id}`;
                                      return (
                                        <Link
                                          to={`/team-history/${id}`}
                                          className={classes.iconLinkPropNormal}
                                        >
                                          <Chip
                                            key={id}
                                            label={name}
                                            avatar={
                                              <Avatar
                                                sx={{
                                                  backgroundColor: "#1976d2",
                                                  color: "#fff !important",
                                                  fontWeight: 600,
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {name.charAt(0)}
                                              </Avatar>
                                            }
                                            // onClick={() =>
                                            //   window.open(
                                            //     `${BASENAME}/team-history/${id}`,
                                            //     "_blank"
                                            //   )
                                            // }
                                            sx={{
                                              margin: 0.5,
                                              backgroundColor: "#e3f2fd",
                                              color: "#1565c0",
                                              cursor: "pointer",
                                              "&:hover": {
                                                backgroundColor: "#bbdefb",
                                              },
                                              "& .MuiTouchRipple-root": {
                                                display: "none",
                                              },
                                            }}
                                          />
                                        </Link>
                                      );
                                    })}
                                  </Stack>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    No members in this group.
                                  </Typography>
                                )}
                              </>
                            )}
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{ textAlign: { xs: "left", md: "right" } }}
                          >
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 0.5 }}
                            >
                              {" "}
                              {dayjs(firstToDo.created_at).format(
                                "MMM D, YYYY"
                              )}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Created by User #
                              {userMap.get(firstToDo.created_by)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      spacing={2}
                      sx={{ padding: isMobile ? 1 : 2 }}
                    >
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            position: "relative",
                            maxHeight: "70vh",
                            minHeight: "70vh",
                            overflowY: "auto",
                            padding: "8px",
                            borderLeft: `4px solid ${theme.palette.primary.main}`,
                            borderRight: `4px solid ${theme.palette.primary.main}`,

                            borderRadius: "8px",
                            // backgroundColor: theme.palette.cardAdd.secBackColor,
                            background: "#f1f2f4",

                            "&::-webkit-scrollbar": {
                              width: "8px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#cccccc",
                              borderRadius: "10px",
                            },
                          }}
                          ref={containerRef}
                          onScroll={handleScroll}
                        >
                          <Grid container spacing={2} direction="column">
                            {coursings.length ? (
                              coursings.map((msg) => {
                                const isMine = msg.is_created_by_me === "yes";
                                return (
                                  <>
                                    <Grid
                                      item
                                      xs={12}
                                      key={msg.id}
                                      container
                                      justifyContent={
                                        isMine ? "flex-end" : "flex-start"
                                      }
                                    >
                                      <Grid
                                        item
                                        sx={{
                                          maxWidth: "80%",
                                          padding: 2,
                                          backgroundColor: isMine
                                            ? "#DCF8C6"
                                            : "#fff",
                                          borderRadius: 3,
                                          boxShadow:
                                            "0 1px 4px rgba(0,0,0,0.1)",
                                          position: "relative",
                                          alignSelf: isMine
                                            ? "flex-end"
                                            : "flex-start",
                                          "&::before": {
                                            content: '""',
                                            display: "block",
                                            position: "absolute",
                                            top: 12,
                                            [isMine ? "right" : "left"]: -6,
                                            width: 10,
                                            height: 10,
                                            backgroundColor: isMine
                                              ? "#DCF8C6"
                                              : "#fff",
                                            transform: isMine
                                              ? "rotate(45deg)"
                                              : "rotate(45deg)",
                                            zIndex: 0,
                                          },
                                        }}
                                      >
                                        {/* Down Arrow Button */}
                                        {isMine && (
                                          <Box
                                            sx={{
                                              position: "absolute",
                                              top: 4,
                                              right: 4,
                                              transition: "opacity 0.2s",
                                            }}
                                          >
                                            <IconButton
                                              size="small"
                                              onClick={(e) => {
                                                setAnchorEl(e.currentTarget);
                                                setCoursingToDelete(msg);
                                              }}
                                            >
                                              <MoreVertIcon fontSize="small" />
                                            </IconButton>
                                          </Box>
                                        )}

                                        {!isMine && (
                                          <Typography
                                            variant="caption"
                                            sx={{
                                              fontWeight: 600,
                                              color: "primary.main",
                                              marginBottom: 1,
                                            }}
                                          >
                                            {userMap.get(msg.created_by) || ""}
                                          </Typography>
                                        )}

                                        <Typography
                                          component="div"
                                          dangerouslySetInnerHTML={{
                                            __html: msg.note,
                                          }}
                                          sx={{
                                            color: "#333",
                                            fontSize: "14px",
                                            lineHeight: "1.6",
                                            marginTop: !isMine ? 0.5 : 0,
                                          }}
                                        />

                                        {/* Mentions */}
                                        {msg.tagged_client_ids.length > 0 && (
                                          <Stack
                                            direction="row"
                                            flexWrap="wrap"
                                            sx={{
                                              maxHeight: 200,
                                              overflowY: "auto",
                                              mt: 1,
                                            }}
                                          >
                                            {msg.tagged_client_ids.map((id) => {
                                              const name =
                                                allClientMap.get(id) ??
                                                `Client #${id}`;
                                              return (
                                                <Chip
                                                  key={id}
                                                  label={`@ ${name}`}
                                                  onClick={() =>
                                                    window.open(
                                                      `${BASENAME}/profile/customer/${id}`,
                                                      "_blank"
                                                    )
                                                  }
                                                  sx={{
                                                    margin: 0.5,
                                                    color: "#1565c0",
                                                    cursor: "pointer",
                                                    backgroundColor: "#e3f2fd",
                                                    fontWeight: 600,
                                                    fontSize: "13px",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "#bbdefb",
                                                    },
                                                  }}
                                                />
                                              );
                                            })}
                                          </Stack>
                                        )}

                                        <Grid
                                          item
                                          sx={{
                                            textAlign: "right",
                                            marginTop: 1,
                                          }}
                                        >
                                          <Typography
                                            variant="subtitle2"
                                            sx={{ color: "primary.main" }}
                                          >
                                            {dayjs(msg.updated_at).format(
                                              "MMM D, YYYY h:mm A"
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    {msg.status === "updated" && (
                                      <Grid
                                        // item
                                        justifyContent={
                                          isMine ? "flex-end" : "flex-start"
                                        }
                                        sx={{
                                          textAlign: isMine ? "right" : "left",
                                          mt: "3px",
                                          mx: 2,
                                        }}
                                      >
                                        <Chip
                                          label={`Edited`}
                                          sx={{
                                            margin: 0.5,
                                            color: "orange",
                                            fontWeight: 600,
                                            fontSize: "13px",
                                            borderRadius: 1,
                                          }}
                                        />
                                      </Grid>
                                    )}
                                  </>
                                );
                              })
                            ) : (
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                ></Typography>
                              </Grid>
                            )}
                          </Grid>

                          {/* Scroll Down Arrow Button */}
                          {showScrollDown && (
                            <IconButton
                              onClick={scrollToBottom}
                              size="small"
                              sx={{
                                position: "sticky",
                                bottom: 8,
                                left: "50%",
                                transform: "translateX(-50%)",
                                bgcolor: "#1976d2",
                                color: "#fff",
                                "&:hover": { bgcolor: "#1565c0" },
                                boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                              }}
                              aria-label="Scroll to last message"
                            >
                              <ArrowDownwardIcon />
                            </IconButton>
                          )}
                        </Box>
                      </Grid>
                      {showEdit && (
                        <Grid item xs={12}>
                          <form onSubmit={formikMessageEdit.handleSubmit}>
                            <Grid
                              container
                              spacing={1}
                              alignItems="flex-end"
                              sx={{
                                backgroundColor: "#d5d5d5",
                                borderRadius: "12px",
                                padding: 2,
                                // border: "1px solid #aaa",
                              }}
                            >
                              <Grid item xs={12}>
                                <Card
                                  elevation={0}
                                  sx={{
                                    border: "1px solid #aaa",
                                    borderRadius: "12px",
                                    padding: 1,
                                    backgroundColor: "#fff",
                                    marginTop: 2,
                                  }}
                                >
                                  {/* <ReactQuill
                                    value={formikMessage.values.note}
                                    onChange={(value) =>
                                      formikMessage.setFieldValue("note", value)
                                    }
                                    placeholder="Type your message..."
                                    theme="snow"
                                    style={{ minHeight: "150px" }}
                                    modules={{
                                      toolbar: [
                                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                        [
                                          "bold",
                                          "italic",
                                          "underline",
                                          "strike",
                                        ],
                                        [{ color: [] }, { background: [] }],
                                        [
                                          { script: "sub" },
                                          { script: "super" },
                                        ],
                                        [
                                          { list: "ordered" },
                                          { list: "bullet" },
                                        ],
                                        [{ indent: "-1" }, { indent: "+1" }],
                                        [{ direction: "rtl" }],
                                        [{ align: [] }],
                                        ["blockquote", "code-block"],
                                        ["clean"],
                                      ],
                                    }}
                                  /> */}

                                  <ReactQuill
                                    value={formikMessageEdit.values.note}
                                    onChange={(value) =>
                                      formikMessageEdit.setFieldValue(
                                        "note",
                                        value
                                      )
                                    }
                                    placeholder="Type your message..."
                                    theme="snow"
                                    // style={{ minHeight: "200px" }}
                                    modules={{
                                      toolbar: [
                                        [{ font: [] }],
                                        [
                                          {
                                            header: [1, 2, 3, 4, 5, 6, false],
                                          },
                                        ],
                                        [
                                          "bold",
                                          "italic",
                                          "underline",
                                          "strike",
                                        ],
                                        [{ color: [] }, { background: [] }],
                                        [
                                          { script: "sub" },
                                          { script: "super" },
                                        ],
                                        [
                                          { list: "ordered" },
                                          { list: "bullet" },
                                        ],
                                        [{ indent: "-1" }, { indent: "+1" }],
                                        [{ direction: "rtl" }],
                                        [{ align: [] }],
                                        ["blockquote", "code-block"],
                                        ["link", "image", "video"],
                                        ["clean"],
                                      ],
                                    }}
                                  />
                                </Card>
                              </Grid>

                              <Grid item xs={12}>
                                <Card
                                  elevation={0}
                                  sx={{
                                    border: "1px solid #aaa",
                                    borderRadius: "12px",
                                    padding: 2,
                                    backgroundColor: "#fafafa",
                                    marginTop: 2,
                                  }}
                                >
                                  <Grid
                                    container
                                    justifyContent={"space-between"}
                                    spacing={5}
                                    sx={{ padding: 2 }}
                                    className={classes.titleGrid}
                                  >
                                    <Grid
                                      item
                                      lg={12}
                                      md={12}
                                      sm={12}
                                      xs={12}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Grid
                                        container
                                        spacing={1}
                                        justifyContent="flex-end"
                                        sx={{ display: "flex" }}
                                      >
                                        <Grid item>
                                          <TextField
                                            InputProps={{
                                              startAdornment: (
                                                <InputAdornment position="start">
                                                  <CiSearch
                                                    className={
                                                      classes.searchWidgetIconPrimary
                                                    }
                                                  />
                                                </InputAdornment>
                                              ),
                                              classes: {
                                                root: classes.formControlList,
                                              },
                                            }}
                                            fullWidth
                                            value={searchQuery}
                                            onChange={(e) =>
                                              setSearchQuery(e.target.value)
                                            }
                                            placeholder="Mobile & Name .."
                                            size="small"
                                            className={
                                              classes.searchTextFieldPrimary
                                            }
                                          />
                                        </Grid>
                                        <Grid item>
                                          <TextField
                                            select
                                            size="small"
                                            sx={{
                                              flexGrow: 1,
                                              width: "100%",
                                            }}
                                            value={selectedClientCat || ""}
                                            onChange={handleIsClientCat}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                              classes: {
                                                root: classes.formControlListStatus,
                                              },
                                            }}
                                            className={
                                              classes.searchTextField34Primary
                                            }
                                          >
                                            <MenuItem value="all">All</MenuItem>
                                            <MenuItem value="parent">
                                              Parent
                                            </MenuItem>
                                            <MenuItem value="child">
                                              Child
                                            </MenuItem>
                                          </TextField>
                                        </Grid>
                                        <Grid item>
                                          <TextField
                                            select
                                            size="small"
                                            sx={{
                                              flexGrow: 1,
                                              width: "100%",
                                            }}
                                            value={selectedClient || ""}
                                            onChange={handleIsClient}
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{
                                              classes: {
                                                root: classes.formControlListStatus,
                                              },
                                            }}
                                            className={
                                              classes.searchTextField34Primary
                                            }
                                          >
                                            <MenuItem value="all">
                                              All Client
                                            </MenuItem>
                                            <MenuItem value="0">
                                              Insurance Client
                                            </MenuItem>
                                            <MenuItem value="1">
                                              Real estate Client
                                            </MenuItem>
                                          </TextField>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Autocomplete
                                    multiple
                                    options={clientOptions}
                                    loading={clientIsLoading}
                                    getOptionLabel={(option: CustomerOption) =>
                                      option.label
                                    }
                                    value={clientOptions.filter((opt) =>
                                      formikMessageEdit.values.tagged_client_ids.includes(
                                        opt.value
                                      )
                                    )}
                                    onChange={(
                                      _,
                                      newValues: CustomerOption[]
                                    ) => {
                                      formikMessageEdit.setFieldValue(
                                        "tagged_client_ids",
                                        newValues.map((val) => val.value)
                                      );
                                    }}
                                    renderTags={(tagValue, getTagProps) =>
                                      tagValue.map((option, index) => (
                                        <Chip
                                          label={option.label}
                                          avatar={
                                            <Avatar>{option.label[0]}</Avatar>
                                          }
                                          {...getTagProps({ index })}
                                          sx={{ margin: 0.5 }}
                                        />
                                      ))
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Add participants..."
                                        fullWidth
                                        // multiline
                                        // rows={2}
                                        size="small"
                                        variant="standard"
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                            <>
                                              {staffIsLoading ? (
                                                <CircularProgress size={20} />
                                              ) : null}
                                              {params.InputProps.endAdornment}
                                            </>
                                          ),
                                        }}
                                      />
                                    )}
                                  />
                                </Card>
                              </Grid>
                              <Grid item xs={6} display="flex" gap={1}>
                                <Tooltip title="Type">
                                  <IconButton
                                    onClick={() => setShowType((prev) => !prev)}
                                    sx={{
                                      backgroundColor: showType
                                        ? "primary.main"
                                        : "#fff",
                                      color: showType ? "#fff" : "primary.main",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <FormatColorTextIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Tag Client">
                                  <IconButton
                                    onClick={() => setShowTag((prev) => !prev)}
                                    sx={{
                                      backgroundColor: showTag
                                        ? "primary.main"
                                        : "#fff",
                                      color: showTag ? "#fff" : "primary.main",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <PersonAddIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Clear">
                                  <IconButton
                                    onClick={() => {
                                      setShowEdit(false);
                                      setCoursingToDelete(null);
                                    }}
                                    sx={{
                                      backgroundColor: showTag
                                        ? "primary.main"
                                        : "#fff",
                                      color: showTag ? "#fff" : "primary.main",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </Tooltip>
                              </Grid>

                              <Grid item xs={6} textAlign="right">
                                <Tooltip title="Sent Message">
                                  <IconButton
                                    onClick={() =>
                                      formikMessageEdit.handleSubmit()
                                    }
                                    disabled={
                                      !formValidMessageEdit || conIsLoading
                                    }
                                    sx={{
                                      color: "white",
                                      backgroundColor: "primary.main",
                                      borderRadius: "8px",
                                      padding: "10px",
                                      transition: "0.3s",
                                      "&:hover": {
                                        backgroundColor: "primary.dark",
                                      },
                                    }}
                                  >
                                    <SendIcon />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </form>
                        </Grid>
                      )}
                      {!showEdit && (
                        <Grid item xs={12}>
                          <form onSubmit={formikMessage.handleSubmit}>
                            <Grid
                              container
                              spacing={1}
                              alignItems="flex-end"
                              sx={{
                                backgroundColor: "#d5d5d5",
                                borderRadius: "12px",
                                padding: 2,
                                // border: "1px solid #aaa",
                              }}
                            >
                              {showType && (
                                <Grid item xs={12}>
                                  <Card
                                    elevation={0}
                                    sx={{
                                      border: "1px solid #aaa",
                                      borderRadius: "12px",
                                      padding: 1,
                                      backgroundColor: "#fff",
                                      marginTop: 2,
                                    }}
                                  >
                                    {/* <ReactQuill
                                    value={formikMessage.values.note}
                                    onChange={(value) =>
                                      formikMessage.setFieldValue("note", value)
                                    }
                                    placeholder="Type your message..."
                                    theme="snow"
                                    style={{ minHeight: "150px" }}
                                    modules={{
                                      toolbar: [
                                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                        [
                                          "bold",
                                          "italic",
                                          "underline",
                                          "strike",
                                        ],
                                        [{ color: [] }, { background: [] }],
                                        [
                                          { script: "sub" },
                                          { script: "super" },
                                        ],
                                        [
                                          { list: "ordered" },
                                          { list: "bullet" },
                                        ],
                                        [{ indent: "-1" }, { indent: "+1" }],
                                        [{ direction: "rtl" }],
                                        [{ align: [] }],
                                        ["blockquote", "code-block"],
                                        ["clean"],
                                      ],
                                    }}
                                  /> */}

                                    <ReactQuill
                                      value={formikMessage.values.note}
                                      onChange={(value) =>
                                        formikMessage.setFieldValue(
                                          "note",
                                          value
                                        )
                                      }
                                      placeholder="Type your message..."
                                      theme="snow"
                                      // style={{ minHeight: "200px" }}
                                      modules={{
                                        toolbar: [
                                          [{ font: [] }],
                                          [
                                            {
                                              header: [1, 2, 3, 4, 5, 6, false],
                                            },
                                          ],
                                          [
                                            "bold",
                                            "italic",
                                            "underline",
                                            "strike",
                                          ],
                                          [{ color: [] }, { background: [] }],
                                          [
                                            { script: "sub" },
                                            { script: "super" },
                                          ],
                                          [
                                            { list: "ordered" },
                                            { list: "bullet" },
                                          ],
                                          [{ indent: "-1" }, { indent: "+1" }],
                                          [{ direction: "rtl" }],
                                          [{ align: [] }],
                                          ["blockquote", "code-block"],
                                          ["link", "image", "video"],
                                          ["clean"],
                                        ],
                                      }}
                                    />
                                  </Card>
                                </Grid>
                              )}

                              {showTag && (
                                <Grid item xs={12}>
                                  <Card
                                    elevation={0}
                                    sx={{
                                      border: "1px solid #aaa",
                                      borderRadius: "12px",
                                      padding: 2,
                                      backgroundColor: "#fafafa",
                                      marginTop: 2,
                                    }}
                                  >
                                    <Grid
                                      container
                                      justifyContent={"space-between"}
                                      spacing={5}
                                      sx={{ padding: 2 }}
                                      className={classes.titleGrid}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid
                                          container
                                          spacing={1}
                                          justifyContent="flex-end"
                                          sx={{ display: "flex" }}
                                        >
                                          <Grid item>
                                            <TextField
                                              InputProps={{
                                                startAdornment: (
                                                  <InputAdornment position="start">
                                                    <CiSearch
                                                      className={
                                                        classes.searchWidgetIconPrimary
                                                      }
                                                    />
                                                  </InputAdornment>
                                                ),
                                                classes: {
                                                  root: classes.formControlList,
                                                },
                                              }}
                                              fullWidth
                                              value={searchQuery}
                                              onChange={(e) =>
                                                setSearchQuery(e.target.value)
                                              }
                                              placeholder="Mobile & Name .."
                                              size="small"
                                              className={
                                                classes.searchTextFieldPrimary
                                              }
                                            />
                                          </Grid>
                                          <Grid item>
                                            <TextField
                                              select
                                              size="small"
                                              sx={{
                                                flexGrow: 1,
                                                width: "100%",
                                              }}
                                              value={selectedClientCat || ""}
                                              onChange={handleIsClientCat}
                                              InputLabelProps={{ shrink: true }}
                                              InputProps={{
                                                classes: {
                                                  root: classes.formControlListStatus,
                                                },
                                              }}
                                              className={
                                                classes.searchTextField34Primary
                                              }
                                            >
                                              <MenuItem value="all">
                                                All
                                              </MenuItem>
                                              <MenuItem value="parent">
                                                Parent
                                              </MenuItem>
                                              <MenuItem value="child">
                                                Child
                                              </MenuItem>
                                            </TextField>
                                          </Grid>
                                          <Grid item>
                                            <TextField
                                              select
                                              size="small"
                                              sx={{
                                                flexGrow: 1,
                                                width: "100%",
                                              }}
                                              value={selectedClient || ""}
                                              onChange={handleIsClient}
                                              InputLabelProps={{ shrink: true }}
                                              InputProps={{
                                                classes: {
                                                  root: classes.formControlListStatus,
                                                },
                                              }}
                                              className={
                                                classes.searchTextField34Primary
                                              }
                                            >
                                              <MenuItem value="all">
                                                All Client
                                              </MenuItem>
                                              <MenuItem value="0">
                                                Insurance Client
                                              </MenuItem>
                                              <MenuItem value="1">
                                                Real estate Client
                                              </MenuItem>
                                            </TextField>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>

                                    <Autocomplete
                                      multiple
                                      options={clientOptions}
                                      loading={staffIsLoading}
                                      getOptionLabel={(
                                        option: CustomerOption
                                      ) => option.label}
                                      value={clientOptions.filter((opt) =>
                                        formikMessage.values.tagged_client_ids.includes(
                                          opt.value
                                        )
                                      )}
                                      onChange={(
                                        _,
                                        newValues: CustomerOption[]
                                      ) => {
                                        formikMessage.setFieldValue(
                                          "tagged_client_ids",
                                          newValues.map((val) => val.value)
                                        );
                                      }}
                                      renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index) => (
                                          <Chip
                                            label={option.label}
                                            avatar={
                                              <Avatar>{option.label[0]}</Avatar>
                                            }
                                            {...getTagProps({ index })}
                                            sx={{ margin: 0.5 }}
                                          />
                                        ))
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          placeholder="Add participants..."
                                          fullWidth
                                          // multiline
                                          // rows={2}
                                          size="small"
                                          variant="standard"
                                          InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                              <>
                                                {staffIsLoading ? (
                                                  <CircularProgress size={20} />
                                                ) : null}
                                                {params.InputProps.endAdornment}
                                              </>
                                            ),
                                          }}
                                        />
                                      )}
                                    />
                                  </Card>
                                </Grid>
                              )}
                              <Grid item xs={6} display="flex" gap={1}>
                                <Tooltip title="Type">
                                  <IconButton
                                    onClick={() => setShowType((prev) => !prev)}
                                    sx={{
                                      backgroundColor: showType
                                        ? "primary.main"
                                        : "#fff",
                                      color: showType ? "#fff" : "primary.main",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <FormatColorTextIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Tag Client">
                                  <IconButton
                                    onClick={() => setShowTag((prev) => !prev)}
                                    sx={{
                                      backgroundColor: showTag
                                        ? "primary.main"
                                        : "#fff",
                                      color: showTag ? "#fff" : "primary.main",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <PersonAddIcon />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Clear">
                                  <IconButton
                                    onClick={() => {
                                      formikMessage.resetForm();
                                      setShowTag(false);
                                      setShowType(false);
                                    }}
                                    sx={{
                                      backgroundColor: showTag
                                        ? "primary.main"
                                        : "#fff",
                                      color: showTag ? "#fff" : "primary.main",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </Tooltip>
                              </Grid>

                              <Grid item xs={6} textAlign="right">
                                <Tooltip title="Sent Message">
                                  <IconButton
                                    onClick={() => formikMessage.handleSubmit()}
                                    disabled={!formValidMessage || conIsLoading}
                                    sx={{
                                      color: "white",
                                      backgroundColor: "primary.main",
                                      borderRadius: "8px",
                                      padding: "10px",
                                      transition: "0.3s",
                                      "&:hover": {
                                        backgroundColor: "primary.dark",
                                      },
                                    }}
                                  >
                                    <SendIcon />
                                  </IconButton>
                                </Tooltip>
                              </Grid>
                            </Grid>
                          </form>
                        </Grid>
                      )}
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        ) : (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card elevation={2} sx={{ borderRadius: 3, p: 2, mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card className={classes.stepperCard}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.activityHistoryHeaderGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Grid
                          container
                          spacing={3}
                          alignItems="flex-start"
                          className={classes.activityHistoryHeaderGrid}
                        >
                          <Grid item xs={12} md={8}>
                            <Grid
                              container
                              spacing={2}
                              alignItems="center"
                              onClick={handleEditClick}
                              sx={{
                                cursor: "pointer",
                                "&:hover .edit-icon": {
                                  opacity: 1,
                                },
                              }}
                            >
                              <Grid item>
                                <Avatar
                                  sx={{
                                    bgcolor: "primary.main",
                                    width: 56,
                                    height: 56,
                                    fontSize: 24,
                                    fontWeight: "bold",
                                  }}
                                >
                                  <GroupIcon />
                                </Avatar>
                              </Grid>
                              <Grid item>
                                <Typography variant="h5" fontWeight={700}>
                                  No task available
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                        className={classes.titleGrid}
                      >
                        <Box
                          sx={{
                            height: "100vh",
                            overflow: "auto",
                            padding: "2px",
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "#eeeeee",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#eeeeee",
                              borderRadius: "10px",
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: "#eeeeee",
                            },
                          }}
                        ></Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        )}

        <Drawer
          anchor="right"
          open={editOpen}
          onClose={handleEditClose}
          PaperProps={{
            sx: {
              width: isMobile ? "100vw" : 600,
              maxWidth: "100vw",
              backgroundColor: theme.palette.background.default,
              padding: isMobile ? 1 : 2,
            },
          }}
        >
          <form onSubmit={formik.handleSubmit}>
            <Grid spacing={2} container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    mb: 3,
                    backgroundColor: theme.palette.cardAdd.bgColor,
                  }}
                >
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ padding: 1 }}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        onClick={handleEditClose}
                        variant="contained"
                        className={classes.editButton}
                      >
                        <CloseIcon />
                      </Button>
                    </Grid>
                    {/* Left side: Avatar + Subject */}
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: "primary.main",
                          width: 56,
                          height: 56,
                          fontSize: 24,
                          fontWeight: "bold",
                        }}
                      >
                        {/* {firstToDo.subject?.charAt(0).toUpperCase()} */}
                        {firstToDo?.subject ? (
                          firstToDo.subject.charAt(0).toUpperCase()
                        ) : (
                          <GroupIcon />
                        )}
                      </Avatar>
                      <Typography
                        className={classes.mL1Heading}
                        fontWeight={700}
                      >
                        {firstToDo?.subject || ""}
                      </Typography>
                    </Grid>

                    {/* Right side: Close button */}
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Subject{" "}
                            <span className={classes.requiedfield}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Autocomplete
                            freeSolo
                            options={
                              meetingAllData?.data?.filter(Boolean) ?? []
                            }
                            loading={meetingAllIsLoading}
                            inputValue={formik.values.subject}
                            onInputChange={(_, value) =>
                              formik.setFieldValue("subject", value)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Subject"
                                size="small"
                                multiline
                                rows={6}
                                className={classes.textField}
                                InputProps={{
                                  ...params.InputProps,
                                  sx: { fontSize: 14 },
                                }}
                                InputLabelProps={{
                                  sx: { fontSize: 14 },
                                }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={4}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Staff{" "}
                            <span className={classes.requiedfield}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Autocomplete
                            multiple
                            options={staffOptions}
                            loading={staffIsLoading}
                            getOptionLabel={(option: CustomerOption) =>
                              option.label
                            }
                            value={staffOptions.filter((opt) =>
                              formik.values.staffIds.includes(opt.value)
                            )}
                            onChange={(_, newValues: CustomerOption[]) => {
                              formik.setFieldValue(
                                "staffIds",
                                newValues.map((val) => val.value)
                              );
                            }}
                            renderTags={(tagValue, getTagProps) =>
                              tagValue.map((option, index) => (
                                <Chip
                                  label={option.label}
                                  avatar={
                                    <Avatar
                                      sx={{
                                        backgroundColor: "#1976d2",
                                        color: "#ffffff !important",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                      }}
                                    >
                                      {option.label[0]}
                                    </Avatar>
                                  }
                                  {...getTagProps({ index })}
                                  sx={{
                                    margin: 0.5,
                                    backgroundColor: "#e3f2fd",
                                    color: "#1565c0",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#bbdefb",
                                    },
                                    "& .MuiTouchRipple-root": {
                                      display: "none",
                                    },
                                  }}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Add participants..."
                                fullWidth
                                // multiline
                                // rows={2}
                                size="small"
                                variant="standard"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {staffIsLoading ? (
                                        <CircularProgress size={20} />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="contained"
                        startIcon={
                          isLoading ? (
                            <CircularProgress
                              size={18}
                              className={classes.isLoading}
                            />
                          ) : (
                            <FaEdit />
                          )
                        }
                        className={classes.addButton}
                        onClick={() => formik.handleSubmit()}
                        disabled={!formValid || isLoading}
                      >
                        Update
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card
                  elevation={2}
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    mb: 3,
                    backgroundColor: theme.palette.cardAdd.bgColor,
                  }}
                >
                  <Grid container justifyContent={"space-between"} spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={1}
                        sx={{ p: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            alignContent: "center",
                          }}
                        >
                          <Typography variant="h5" color="primary">
                            History
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Box
                        sx={{
                          height: "80vh",
                          overflow: "auto",
                          padding: "2px",
                          // background: theme.palette.cardAdd.thirdBgColor,
                          borderRadius: 3,
                          "&::-webkit-scrollbar": {
                            width: "4px",
                          },
                          "&::-webkit-scrollbar-track": {
                            background: "#eeeeee",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            background: "#eeeeee",
                            borderRadius: "10px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            background: "#eeeeee",
                          },
                        }}
                      >
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={1}
                          sx={{ px: 1, pb: 3 }}
                          className={classes.titleGrid}
                        >
                          {/* <Grid item lg={12} md={12} sm={12} xs={12}> */}
                          {conversationsHistoriesList.map(
                            (row: IToDoHistory, index) => {
                              const prevRow =
                                index > 0
                                  ? conversationsHistoriesList[index - 1]
                                  : null;

                              const areEqual = (a: any, b: any) => {
                                if (Array.isArray(a) && Array.isArray(b)) {
                                  return (
                                    a.length === b.length &&
                                    a.every((val, i) => val === b[i])
                                  );
                                }
                                return a === b;
                              };

                              const getChangedProperties = (
                                current: any,
                                previous: any
                              ) => {
                                if (!previous) return {};
                                const changedProps: Record<
                                  string,
                                  { oldValue: any; newValue: any }
                                > = {};

                                Object.keys(current).forEach((key) => {
                                  if (key === "id") return;
                                  if (!areEqual(current[key], previous[key])) {
                                    changedProps[key] = {
                                      oldValue: previous[key],
                                      newValue: current[key],
                                    };
                                  }
                                });

                                return changedProps;
                              };

                              const changedProperties = getChangedProperties(
                                row,
                                prevRow
                              );

                              // ✅ Filter out changes with both old and new value as null/empty
                              const meaningfulChanges = Object.entries(
                                changedProperties
                              ).filter(([key, { oldValue, newValue }]) => {
                                if (key === "conversations_created_at")
                                  return false;
                                if (key === "updated_by") return false;
                                if (key === "created_by") return false;

                                const isEmpty = (val: any) =>
                                  val === null ||
                                  val === undefined ||
                                  val === "" ||
                                  val === "null" ||
                                  (Array.isArray(val) && val.length === 0);

                                return !(
                                  isEmpty(oldValue) && isEmpty(newValue)
                                );
                              });

                              const hasChanges = meaningfulChanges.length > 0;

                              if (!prevRow || !hasChanges) return null;

                              return (
                                <Grid
                                  item
                                  xs={12}
                                  key={row.id}
                                  mt={index === 1 ? 0 : 4}
                                >
                                  <Card
                                    elevation={2}
                                    sx={{
                                      boxShadow: "none",
                                      borderRadius: 3,
                                      backgroundColor:
                                        theme.palette.cardAdd.bgColor,
                                      borderLeft: `4px solid ${theme.palette.primary.main}`,
                                    }}
                                  >
                                    <CardContent>
                                      <Typography
                                        variant="subtitle2"
                                        color="primary"
                                        gutterBottom
                                      >
                                        <Box
                                          display="flex"
                                          justifyContent="space-between"
                                        >
                                          <span>— Updated —</span>
                                          {(prevRow.conversations_created_at ||
                                            prevRow.updated_by) && (
                                            <span>
                                              {dayjs(
                                                prevRow.conversations_created_at
                                              ).format("YYYY-MM-D hh:mm A")}
                                              {" / "}
                                              {userMap.get(prevRow.updated_by)}
                                            </span>
                                          )}
                                        </Box>
                                      </Typography>

                                      <Divider sx={{ mb: 2 }} />

                                      {meaningfulChanges.map(
                                        ([key, { oldValue, newValue }]) => {
                                          let displayOld = String(oldValue);
                                          let displayNew = String(newValue);

                                          if (key === "staffIds") {
                                            displayOld = Array.isArray(oldValue)
                                              ? oldValue
                                                  .map(
                                                    (id: any) =>
                                                      staffMap.get(id) || ""
                                                  )
                                                  .join(", ")
                                              : staffMap.get(oldValue) || "";
                                            displayNew = Array.isArray(newValue)
                                              ? newValue
                                                  .map(
                                                    (id: any) =>
                                                      staffMap.get(id) || ""
                                                  )
                                                  .join(", ")
                                              : staffMap.get(newValue) || "";
                                          }
                                          return (
                                            <Stack spacing={2} mt={1}>
                                              <Typography
                                                key={key}
                                                variant="subtitle1"
                                                sx={{
                                                  mt: 1,
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: 1,
                                                }}
                                              >
                                                <strong>
                                                  {variantPropName(key)}
                                                </strong>
                                                :&nbsp;
                                                {/* {displayNew &&
                                                    displayNew !== "null" && (
                                                      <span>{displayNew}</span>
                                                    )}
                                                  <IoIosArrowRoundForward
                                                    style={{
                                                      fontSize: 22,
                                                      color: "#1976d2",
                                                    }}
                                                  /> */}
                                                {displayOld &&
                                                  displayOld !== "null" && (
                                                    <span>{displayOld}</span>
                                                  )}
                                              </Typography>
                                            </Stack>
                                          );
                                        }
                                      )}
                                    </CardContent>
                                  </Card>
                                </Grid>
                              );
                            }
                          )}

                          {conversationsHistoriesList.length > 0 && (
                            <Grid item xs={12} mt={4}>
                              <Card
                                elevation={2}
                                sx={{
                                  boxShadow: "none",
                                  borderRadius: 3,
                                  backgroundColor:
                                    theme.palette.cardAdd.bgColor,
                                  borderLeft: `4px solid ${theme.palette.primary.main}`,
                                }}
                              >
                                <CardContent>
                                  <Typography
                                    variant="subtitle2"
                                    color="primary"
                                    gutterBottom
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                    >
                                      <span>— Created —</span>
                                      {(conversationsHistoriesList[
                                        conversationsHistoriesList.length - 1
                                      ].conversations_created_at ||
                                        conversationsHistoriesList[
                                          conversationsHistoriesList.length - 1
                                        ].updated_by) && (
                                        <span>
                                          {dayjs(
                                            conversationsHistoriesList[
                                              conversationsHistoriesList.length -
                                                1
                                            ].conversations_created_at
                                          ).format("YYYY-MM-D hh:mm A")}
                                          {" / "}
                                          {userMap.get(
                                            conversationsHistoriesList[
                                              conversationsHistoriesList.length -
                                                1
                                            ].created_by
                                          )}
                                        </span>
                                      )}
                                    </Box>
                                  </Typography>

                                  <Divider sx={{ mt: 1, mb: 2 }} />

                                  <Stack spacing={1} mt={1}>
                                    {Object.entries(
                                      conversationsHistoriesList[
                                        conversationsHistoriesList.length - 1
                                      ]
                                    ).map(([key, value]) => {
                                      if (
                                        [
                                          "id",
                                          "conversations_created_at",
                                          "updated_by",
                                          "created_by",
                                          "isLooping",
                                        ].includes(key)
                                      )
                                        return null;

                                      let displayValue = String(value);

                                      if (key === "staffIds") {
                                        displayValue = Array.isArray(value)
                                          ? value
                                              .map(
                                                (id: any) =>
                                                  staffMap.get(id) || ""
                                              )
                                              .join(", ")
                                          : staffMap.get(value) || "";
                                      }
                                      const isEmpty =
                                        displayValue === "" ||
                                        displayValue === "null" ||
                                        displayValue === null;

                                      return !isEmpty ? (
                                        <Stack spacing={2} mt={1}>
                                          <Typography
                                            key={key}
                                            variant="subtitle1"
                                            sx={{
                                              mt: 1,
                                              display: "flex",
                                              alignItems: "center",
                                              gap: 1,
                                            }}
                                          >
                                            <strong>
                                              {variantPropName(key)}
                                            </strong>
                                            :&nbsp;
                                            {displayValue &&
                                              displayValue !== "null" && (
                                                <span>{displayValue}</span>
                                              )}
                                          </Typography>
                                        </Stack>
                                      ) : null;
                                    })}
                                  </Stack>
                                </CardContent>
                              </Card>
                            </Grid>
                          )}
                          {/* </Grid> */}
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </form>
        </Drawer>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            sx: {
              borderRadius: 2,
              minWidth: 140,
              boxShadow: 3,
              backgroundColor: theme.palette.cardAdd.bgColor,
              "& .MuiMenuItem-root": {
                fontSize: 14,
                fontWeight: 500,
              },
            },
          }}
        >
          <MenuItem onClick={handleEdit}>✏️ Edit</MenuItem>
          <MenuItem onClick={handleDelete2}>🗑️ Delete</MenuItem>

          {coursingToDelete && coursingToDelete?.read_by_staff?.length > 0 && (
            <>
              <Divider sx={{ my: 1 }} />
              <Typography
                variant="subtitle2"
                sx={{
                  px: 2,
                  pt: 0.5,
                  pb: 0.5,
                  fontWeight: 600,
                  // fontSize: "13px",
                  // color: "#607d8b", // Soft blue-grey tone
                }}
              >
                ☑️ Read By
              </Typography>

              {coursingToDelete.read_by_staff.map((reader) => (
                <MenuItem
                  key={reader.staff_id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    opacity: 1,
                    py: 1,
                    px: 2,
                    cursor: "default",
                    "&.Mui-disabled": {
                      backgroundColor: "transparent",
                    },
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <Stack direction="column" spacing={0.3}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                      }}
                    >
                      {reader.staff}
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: "12px" }}>
                      {dayjs(reader.read_at).format("MMM D, YYYY h:mm A")}
                    </Typography>
                  </Stack>
                </MenuItem>
              ))}
            </>
          )}
        </Menu>

        {coursingToDelete && !showEdit && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Message?"
            content={`Are you sure you want to permanently delete this message? This action cannot be undone.`}
          />
        )}
      </Grid>
    </div>
  );
};

export default Index;
